import { Divider, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useWizardStepContext } from 'v2/components/WizardModal';
import { HOME_PATH } from 'v2/paths';

const STEP_INDEX = 2;

const AdminAccountCreatedStep: React.FC<React.PropsWithChildren> = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);
  const { setFooterContent, activeStep } = useWizardStepContext();

  useEffect(() => {
    if (activeStep === STEP_INDEX) {
      let intervalId = null;

      if (countdown > 0) {
        intervalId = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);
      }

      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }
  }, [countdown, activeStep]);

  React.useLayoutEffect(() => {
    setFooterContent(STEP_INDEX, <></>);
  }, []);

  useEffect(() => {
    if (countdown === 0) {
      navigate(HOME_PATH);
    }
  }, [countdown]);

  return (
    <Stack flexDirection="column" gap="16px">
      <Typography variant="h4" color="textPrimary">
        Admin account created
      </Typography>
      <Divider />
      <Typography variant="body1" color="textPrimary">
        In a few seconds we will redirect you to the login page where you can use your new credentials to enter the
        ATLAS Portal.
      </Typography>
      <Typography variant="h5" alignSelf="center" color="textPrimary">
        {countdown}
      </Typography>
    </Stack>
  );
};

export default AdminAccountCreatedStep;
